import { CultureState } from '@/store';

export interface INumberFormattingOptions {
    localeMatcher?: 'lookup' | 'best fit';
    style?: 'decimal' | 'percent' | 'currency';
    currency?: string;
    currencyDisplay?: 'symbol' | 'code' | 'name';
    useGrouping?: boolean;
    minimumIntegerDigits?: number;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
    minimumSignificantDigits?: number;
    maximumSignificantDigits?: number;
}

export interface IMeasureFormattingOptions {
    separator: string;
    numberFormattingOptions: INumberFormattingOptions;
    measures: IMeasure[];
}

export interface IMeasure {
    power: number;
    measure: string;
}

export class Formatter {

    public static numberToMeasureString(value: number,
                                        formattingOptions: IMeasureFormattingOptions): string {

        if (typeof value !== 'number') { throw new Error('value must be a number'); }
        if (!formattingOptions) { throw new Error('measureFormattingOptions is not set'); }
        if (!formattingOptions.measures
            || formattingOptions.measures.length < 1) { throw new Error('measureFormattingOptions.measures must have at least one element'); }

        const numberOfIntDigits = Math.log10(value);
        const measure = Formatter.selectMeasure(formattingOptions.measures, numberOfIntDigits);

        const measureValue = value / Math.pow(10, measure.power);
        const strMeasureValue = measureValue.toLocaleString('ru-RU', formattingOptions.numberFormattingOptions);

        const result = `${strMeasureValue}${formattingOptions.separator}${measure.measure}`;

        return result;
    }
    public static dateToString(value: Date,
                               formattingOptions?: Intl.DateTimeFormatOptions): string {

        let locale;
        const culture = CultureState.currentCulture;
        if (!culture || !culture.locale) {
            locale = undefined;
        } else {
            locale = culture.locale;
        }

        const result = value.toLocaleString(locale, formattingOptions);

        return result;
    }

    private static selectMeasure(measures: IMeasure[], numberOfIntDigitsInValue: number): IMeasure {

        let idxMeasure = 0;
        let numberOfIntDigitsWithMeasure = null;
        for (let i = 0; i < measures.length; i++) {
            const measure = measures[i];
            const delta2 = numberOfIntDigitsInValue - measure.power;
            if (delta2 >= 0
                && (numberOfIntDigitsWithMeasure === null
                    || delta2 < numberOfIntDigitsWithMeasure)
               ) {
                idxMeasure = i;
                numberOfIntDigitsWithMeasure = delta2;
            }
        }

        if (numberOfIntDigitsWithMeasure === null) {
            let minPower = measures[0].power;
            for (let i = 1; i < measures.length; i++) {
                const measure = measures[i];
                if (measure.power < minPower) {
                    idxMeasure = i;
                    minPower = measure.power;
                }
            }
        }

        return measures[idxMeasure];
    }
}
